var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccent = function SvgAccent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".accent_svg__cls-1{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accent_svg__Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 5,
    width: 3,
    height: 8.25,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent_svg__cls-1",
    d: "M6 15a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 5,
    width: 3,
    height: 6.25,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent_svg__cls-1",
    d: "M12 13a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 5,
    width: 3,
    height: 4.25,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 2
  }))));
};
export default SvgAccent;